import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEcdConnectEmojiUnhappy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19 38C29.4932 38 38 29.4932 38 19C38 8.50677 29.4932 0 19 0C8.50677 0 0 8.50677 0 19C0 29.4932 8.50677 38 19 38Z",
			fill: "#FF5C00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2158 23.5913C20.9317 22.7485 20.157 22.1657 19.2681 22.122C18.3549 22.0782 17.4855 22.6538 17.1673 23.5087C17.0556 23.8098 16.7715 24.0114 16.4412 23.9216C16.1522 23.8414 15.9166 23.4966 16.0283 23.1954C16.5383 21.8281 17.7939 20.9174 19.2681 20.9416C20.6937 20.9659 21.908 21.952 22.3524 23.278C22.5953 24.0017 21.4563 24.3101 21.2134 23.5913",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2946 15.7459C11.2946 17.8343 9.60199 19.5294 7.51112 19.5294C5.42024 19.5294 3.72763 17.8368 3.72763 15.7459C3.72763 13.655 5.42267 11.9624 7.51112 11.9624C9.59956 11.9624 11.2946 13.6574 11.2946 15.7459Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.40184 14.2817C7.40184 14.896 6.90401 15.3939 6.28962 15.3939C5.67523 15.3939 5.1774 14.896 5.1774 14.2817C5.1774 13.6673 5.67523 13.1694 6.28962 13.1694C6.90401 13.1694 7.40184 13.6673 7.40184 14.2817Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.62091 16.0351C8.62091 16.3897 8.33435 16.6763 7.9798 16.6763C7.62525 16.6763 7.3387 16.3897 7.3387 16.0351C7.3387 15.6806 7.62525 15.394 7.9798 15.394C8.33435 15.394 8.62091 15.6806 8.62091 16.0351Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.2699 15.7459C34.2699 17.8343 32.5749 19.5294 30.4865 19.5294C28.398 19.5294 26.703 17.8368 26.703 15.7459C26.703 13.655 28.398 11.9624 30.4865 11.9624C32.5749 11.9624 34.2699 13.6574 34.2699 15.7459Z",
			fill: "#1C1C1C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3747 14.2817C30.3747 14.896 29.8769 15.3939 29.2625 15.3939C28.6481 15.3939 28.1503 14.896 28.1503 14.2817C28.1503 13.6673 28.6481 13.1694 29.2625 13.1694C29.8769 13.1694 30.3747 13.6673 30.3747 14.2817Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5938 16.0351C31.5938 16.3897 31.3073 16.6763 30.9527 16.6763C30.5982 16.6763 30.3116 16.3897 30.3116 16.0351C30.3116 15.6806 30.5982 15.394 30.9527 15.394C31.3073 15.394 31.5938 15.6806 31.5938 16.0351Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2285 22.7544C10.2285 23.818 9.07016 24.6801 7.63982 24.6801C6.20948 24.6801 5.04869 23.818 5.04869 22.7544C5.04869 21.6907 6.20948 20.8286 7.63982 20.8286C9.07016 20.8286 10.2285 21.6907 10.2285 22.7544Z",
			fill: "#FFD525"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.9489 22.7544C32.9489 23.818 31.7905 24.6801 30.3602 24.6801C28.9298 24.6801 27.769 23.818 27.769 22.7544C27.769 21.6907 28.9298 20.8286 30.3602 20.8286C31.7905 20.8286 32.9489 21.6907 32.9489 22.7544Z",
			fill: "#FFD525"
		})
	]
});
export default SvgEcdConnectEmojiUnhappy;
